import JsonapiClient from '@holidayextras/jsonapi-client';
import { authService } from '../../utils/auth-service';

const client = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
  header: {
    Authorization: `Bearer ${authService.getToken()}`,
  },
});

export function getReviews(influencerID, organisationID) {
  return client.find('review', { filter: { influencer: influencerID, organisation: organisationID }, include: ['createdBy'], sort: ['createdDate'] });
}

export function setReview(data) {
  const review = client.create('review');
  const date = new Date();

  review.set('rating', data.rating);
  review.set('content', data.content);
  review.set('organisation', { type: 'organisations', id: data.organisation });
  review.set('influencer', { type: 'influencer', id: data.influencer });
  review.set('createdBy', { type: 'users', id: data.user });
  review.set('createdDate', date);

  return review.sync();
}

export function updateInfluencerDetails(influencerDetails, review) {
  return client.get('influencerDetails', influencerDetails, { include: ['reviews'] })
    .then(response => {
      const length = response.toJSONTree().reviews.length + 1;
      let total = review.toJSONTree().rating;
      response.toJSONTree().reviews.forEach(r => {
        total += r.rating;
      });
      const avg = Math.round(total / length);
      response.set('assessment', avg);
      response.relationships('reviews').add(review);
      return response.sync();
    });
}



/** WEBPACK FOOTER **
 ** ./src/components/influencer-reviews/utils.js
 **/